var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 45,
    cy: 45,
    r: 45,
    fill: "rgba(29,187,190,0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17766",
    "data-name": "Group 17766",
    transform: "translate(7.997 12.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11081",
    "data-name": "Path 11081",
    d: "M60.966,1.727A1.4,1.4,0,0,0,60.477.314,1.348,1.348,0,0,0,59.007.18L3.13,29.9A4.073,4.073,0,0,0,2.858,36.9h0L15.3,44.873a.674.674,0,0,0,.818-.066L49.279,14.728a.672.672,0,0,1,.934,0,.7.7,0,0,1,.05.947L23.762,49.4a.7.7,0,0,0,.169,1.016L41.477,61.677a3.917,3.917,0,0,0,3.615.32,4.008,4.008,0,0,0,2.359-2.8Z",
    transform: "translate(0 0)",
    fill: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11082",
    "data-name": "Path 11082",
    d: "M8.315,19.225a.531.531,0,0,0-.815.446c0,2.234,0,7.584,0,7.584a2.116,2.116,0,0,0,3.611,1.5l4.269-4.267a.531.531,0,0,0-.091-.821Z",
    transform: "translate(12.056 36.001)",
    fill: "#1dbbbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e328d984c24eb938b2a2275941e0bb4d.svg";
export { ForwardRef as ReactComponent };